







































































import { Component, Vue, Prop } from 'vue-property-decorator'
import AllPreviewComps from './comp-preview/index'
import FloatComp from './comp-preview/comp-float.vue'
import * as weixin from '@ivy/fts/weixin'
import { env } from '@ivy/fts/envInfo/envInfo'
import { uploadEvent } from '@/api/goods/statistics'
import * as helper from '@/helper'
import Modal from './comp-preview/modal/index.vue'
import NoAuth from './common/no-auth.vue'
import { convertPxToVw } from './utils'

const openRule: any = [
  {
    value: 'day',
    label: '每天第一次打开',
  },
  {
    value: 'every',
    label: '每次打开',
  },
  {
    value: 'only',
    label: '只弹一次',
  },
  {
    value: 'week',
    label: '每周第一次打开',
  },
]

@Component({
  components: {
    FloatComp,
    Modal,
    NoAuth,
  },
})
export default class Preview extends Vue {
  allComps: any[] = []
  previewComps: any[] = []
  floatComps: any[] = []
  modalComp: any = {}
  pageComp: any = {}
  needShowModal: boolean = false
  showFilter: boolean = false
  filterData: any = {}
  filterItem: any = {}
  showAuth: boolean = false
  isHidden: boolean = false // 页面是否处于隐藏状态
  loadQueue: any[] = []
  isAppTab: any // 用来判断是有在app页签内
  pageId: any = null
  extraConfig: any = {}
  stickyTop: number = 0
  inited: boolean = false // 初始化 env 和 uploadEvent
  get getComp() {
    return item => {
      let type = item.type
      if (type) {
        let compName =
          type.substr(0, 1).toUpperCase() + type.substr(1) || 'Empty'
        return AllPreviewComps[compName]
      }
      return AllPreviewComps['Empty']
    }
  }

  // 处理按钮置低问题
  get pageStyle() {
    return {
      background: this.pageComp.bgColor || '#FFFFFF',
    }
  }

  get pagePadding() {
    let buttons = this.previewComps.filter(
      r => r.type === 'button' && r.position === 'bottom'
    )
    let padding = 0
    for (const item of buttons) {
      padding += (100 / 375) * 61
    }
    return {
      paddingBottom: `${padding}vw`,
      boxSizing: 'border-box',
    }
  }

  get uploadEvent() {
    return uploadEvent
  }

  async created() {
    this.isAppTab = this.$route.query.isAppTab || ''
    this.pageId = this.$route.query.page_id || ''
    if (+this.isAppTab) this.isHidden = true
    // 初始化曝光事件
    this.initDisplayEvent()
    await env.init()
    await uploadEvent.init()
    this.inited = true
    this.loadData()
    setTimeout(this.exposureEvent, 1111)
  }

  async loadData() {
    console.log('page -> shop')
    let isDraft = this.$route.query.is_draft || ''

    let id = this.$route.query.page_id
    if (id) {
      let { data } = await this.$axios.get(
        `/api/mobile/h5/microPage/infoByPageId`,
        {
          params: {
            id,
            draft: +isDraft,
          },
        }
      )
      this.$title(data.config.title || '商城')
      this.pageComp = data.config.pageComp || {}
      this.allComps = data.items_config
      let hasLift = this.allComps.find(item => {
        return item.type === 'lift' && item.navType === 0
      })
      this.previewComps = data.items_config.filter(item => {
        return item.documentModal === 'normal' || !item.documentModal
      })
      this.floatComps =
        data.items_config.filter(item => {
          return item.documentModal === 'float'
        }) || []
      this.modalComp =
        data.items_config.filter(item => {
          return item.documentModal === 'modal'
        })[0] || {}
      if (data.vip_config) {
        this.extraConfig.vip_config = data.vip_config
      }
      if (data.sale_config) {
        this.extraConfig.sale_config = data.sale_config
      }

      let canShare = this.pageComp.canShare
      this.setShare(canShare)
      // // 初始化曝光事件,非 app 内
      // this.initDisplayEvent()
      if (env.type !== 'ivydad') {
        this.visibilityChange()
        document.addEventListener('visibilitychange', this.visibilityChange)
      }
      // ----------------- 用户过滤规则
      this.userFilter()
      // -----------------  用户过滤规则
      this.initShowModal()

      if (hasLift) {
        await this.$nextTick()
        let liftEl = document.querySelector('.preview-lift-title') as any
        let height = liftEl.offsetHeight

        let liftIndex = this.allComps.findIndex(item => item.type === 'lift')
        this.previewComps = this.previewComps.map((comp, idx) => {
          if (
            (comp.type === 'group' || comp.type === 'leave') &&
            idx > liftIndex
          ) {
            comp.stickyTop = height
          }
          return comp
        })
        // let groupIndex = this.allComps.findIndex(item => item.type === 'group')
        // if (liftIndex < groupIndex) {
        //   this.stickyTop = height
        // }
      }
    } else {
      this.$Toast('缺少参数page_id')
    }
  }

  // 用户过滤规则
  userFilter() {
    this.previewComps = this.previewComps.filter(item => {
      return (
        item.has_auth ||
        (!item.has_auth && item.filter && !item.filter.hiddenFilterLink)
      )
    })
    this.floatComps = this.floatComps.filter(item => {
      return (
        item.has_auth ||
        (!item.has_auth && item.filter && !item.filter.hiddenFilterLink)
      )
    })
    if (!this.modalComp.has_auth && this.modalComp.filter) {
      if (this.modalComp.filter.hiddenFilterLink) {
        this.modalComp = {}
      } else {
        this.modalComp = {
          ...this.modalComp,
          ...this.modalComp.filter.filterLink,
        }
      }
    }
    this.showAuth =
      !this.previewComps.length &&
      !this.floatComps.length &&
      !Object.keys(this.modalComp).length
  }

  initShowModal() {
    let openRule = this.modalComp.openRule
    let id = this.$route.query.page_id
    let openTime = window.localStorage.getItem('open-modal-' + id)
    if (!openRule) {
      window.localStorage.setItem('open-modal-' + id, '')
      return
    }
    switch (openRule) {
      case 'day':
        if (!openTime) {
          this.showModal()
        } else {
          let isSameDay =
            +new Date(+openTime) === +new Date(new Date().format('YYYY-MM-DD'))
          if (!isSameDay) {
            this.showModal()
          }
        }
        break
      case 'every':
        this.needShowModal = true
        window.localStorage.setItem('open-modal-' + id, '')
        break
      case 'week':
        if (!openTime) {
          this.showModal()
        } else {
          var now = new Date()
          var weekFirstDay = new Date(+now - (now.getDay() - 1) * 86400000)
          var weekLastDay = new Date((+weekFirstDay / 1000 + 6 * 86400) * 1000)

          let inWeek =
            +new Date(+openTime) > +weekFirstDay &&
            +new Date(+openTime) < +weekLastDay

          console.log(
            new Date(+openTime).format('YYYY-MM-DD'),
            new Date(weekFirstDay).format('YYYY-MM-DD'),
            new Date(weekLastDay).format('YYYY-MM-DD')
          )
          if (!inWeek) {
            this.showModal()
          }
        }
        break
      case 'only':
        if (!openTime) {
          this.showModal()
        }
        break
      default:
        break
    }
  }
  showModal() {
    this.needShowModal = true
    let id = this.$route.query.page_id
    window.localStorage.setItem(
      'open-modal-' + id,
      new Date(new Date().format('YYYY-MM-DD')).getTime() + ''
    )
  }
  async setShare(open) {
    let link = window.location.href
    if (env.type === 'wx') {
      if (open) {
        let options = {
          title: this.pageComp.shareTitle,
          desc: this.pageComp.shareDesc,
          imgUrl: this.pageComp.sharePic,
          link: encodeURI(link),
        }
        await weixin.weixinShare(options)
      } else {
        helper.hideWxShare()
      }
    } else if (env.type === 'ivydad') {
      if (open) {
        let options = {
          title: this.pageComp.shareTitle,
          content: this.pageComp.shareDesc,
          url: link,
          pic_url: this.pageComp.sharePic,
          audio_url: '',
          type: 'web',
        }
        await env.init()
        await env.shareInfo(options)
      } else {
        let hasHideShareRemark = location.href.indexOf('_hideShareButton') > -1
        if (!hasHideShareRemark) {
          window.location.href = window.location.href + '&_hideShareButton=1'
        }
      }
    }
  }
  closeModal() {
    this.modalComp = {}
  }

  // 电商埋点-微页面组件点击
  async clickEvent(item, e: MouseEvent) {
    if (item.type === 'group') return
    // 用户过滤规则判定
    if (!item.has_auth && item.type !== 'modal') {
      e.stopPropagation()
      this.filterData = item.filter && item.filter.filterLink
      this.filterItem = item
      this.showFilter = true
    }
    if (!item.title) return
    if (
      [
        'title',
        'picture',
        'album',
        'video',
        'nav',
        'goods',
        'suspend',
        'coupon',
        'ebook',
        'modal',
        'button',
      ].includes(item.type)
    )
      return
    await uploadEvent.sendRecord(
      'Click_MicroPages_Component',
      '',
      {
        PageName: document.title,
        ComponentName: item.title,
        isTabPage: +this.isAppTab ? 'Y' : 'N',
      },
      [
        ['p1', 'PageName'],
        ['p2', 'ComponentName'],
        ['p3', 'isTabPage'],
      ]
    )
  }

  // 组件曝光事件监听
  exposureEvent() {
    let loaded = []
    let comps = document.querySelectorAll('.comp-item')
    if (typeof IntersectionObserver !== 'function') return
    let io = new IntersectionObserver(e => {
      e.forEach(el => {
        if (
          el &&
          (el.intersectionRatio > 0 ||
            el.target.getAttribute('type') === 'float')
        ) {
          let config = this.allComps.find(
            c => c._id === el.target.getAttribute('data-item-id')
          )
          if (!config) return
          if (!loaded.includes(config._id)) {
            if (this.isHidden) {
              // 这里如果是页签隐藏状态存到队列中等待上报
              this.loadQueue.push(config)
            } else {
              // 电商埋点-微页面组件曝光
              uploadEvent.sendRecord(
                'Exposure_MicroPages_Component',
                '',
                {
                  PageName: document.title,
                  ComponentName: config.title,
                  isTabPage: +this.isAppTab ? 'Y' : 'N',
                },
                [
                  ['p1', 'PageName'],
                  ['p2', 'ComponentName'],
                  ['p3', 'isTabPage'],
                ],
                { useCurPageName: +this.isAppTab }
              )
            }
            loaded.push(config._id)
          }
        }
      })
    })
    comps.forEach(el => io.observe(el))
  }

  // 需求: 兼容静默加载，页面显示时才曝光
  initDisplayEvent() {
    // console.log('ccccc', this.isAppTab, this.isHidden)
    if (this.isAppTab) {
      let that = this
      ;(window as any)._isDisplayingOnScreen = async function(e) {
        console.log('_isDisplayingOnScreen被触发: ', e)
        if (!that.inited) {
          await env.init()
          await uploadEvent.init()
        }
        that.inited = true
        that.visibilityChange(e)
        return e
      }
    }
  }

  visibilityChange(isOnScreen?) {
    let preState = this.isAppTab ? this.isHidden : true
    this.isHidden = this.isAppTab ? !isOnScreen : document.hidden
    console.log(`当前页面是否在屏幕上: ${isOnScreen}`, this.isHidden)
    if (preState && !this.isHidden) {
      console.log('触发埋点曝光')
      // 电商埋点微页面曝光
      // 1、上报页面曝光事件
      uploadEvent[+this.isAppTab ? 'sendRecord' : 'sendPV'](
        'Exposure_Page',
        '',
        {
          PageName: document.title,
          FromPage: 1,
          isTabPage: +this.isAppTab ? 'Y' : 'N',
        },
        [
          ['p1', 'PageName'],
          ['p2', 'FromPage'],
          ['p3', 'isTabPage'],
        ],
        { useCurPageName: +this.isAppTab }
      )
        .then(() => {
          // 2、上报自定义页面曝光事件
          uploadEvent.sendRecord(
            'Exposure_MicroPages',
            '',
            {
              PageName: document.title,
              FromPage: 1,
              isTabPage: +this.isAppTab ? 'Y' : 'N',
            },
            [
              ['p1', 'PageName'],
              ['p2', 'FromPage'],
              ['p3', 'isTabPage'],
            ],
            { useCurPageName: +this.isAppTab }
          )
        })
        .then(() => {
          // 3、清空队列中的组件曝光事件
          while (this.loadQueue.length) {
            uploadEvent.sendRecord(
              'Exposure_MicroPages_Component',
              '',
              {
                PageName: document.title,
                ComponentName: this.loadQueue.shift().title,
                isTabPage: +this.isAppTab ? 'Y' : 'N',
              },
              [
                ['p1', 'PageName'],
                ['p2', 'ComponentName'],
                ['p3', 'isTabPage'],
              ],
              { useCurPageName: +this.isAppTab }
            )
          }
        })
    }
  }

  destroyed() {
    if (this.isAppTab) {
      delete window['_isDisplayingOnScreen']
    } else {
      document &&
        document.removeEventListener &&
        document.removeEventListener('visibilitychange', this.visibilityChange)
    }
  }
}
